// Création de l'objet à envoyer au back
const formaterFichierPermisDeChasse = async (dataForm) => {
    return dataForm.permisDeChasse ? dataForm.permisDeChasse[0].getFileToSend() : null;
};

export default formaterFichierPermisDeChasse;
